// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Component, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScreenLayoutService } from '../../shared/services/screen-layout-service/screen-layout.service';

import { ServiceTicketsTableDesktopComponent } from '../service-tickets-table-desktop/service-tickets-table-desktop.component';
import { ServiceTicketsTableMobileComponent } from '../service-tickets-table-mobile/service-tickets-table-mobile.component';

import { SpTicketModel } from '../interfaces/sp-ticket-model';
import { SpSortEventModel } from '../model/sp-sort-event-model';

@Component({
  selector: 'app-service-tickets',
  standalone: true,
  imports: [
    CommonModule,
    ServiceTicketsTableDesktopComponent,
    ServiceTicketsTableMobileComponent,
  ],
  templateUrl: './service-tickets.component.html',
  styleUrl: './service-tickets.component.scss',
})
export class ServiceTicketsComponent {
  tickets = input<SpTicketModel[]>([]);
  sortChange = output<SpSortEventModel>();

  protected screenLayoutService = inject(ScreenLayoutService);

  protected onSortChange(change: SpSortEventModel): void {
    this.sortChange.emit(change);
  }
}
